module.exports = __webpack_public_path__ + "101ba52a87f0639c9e51f7b56aede625.svg";